import * as React from 'react';

function ContactUs() {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Contact Us</strong></p>
        <div >
          You can reach us at <a href="mailto:support@decodeinvesting.com">support@decodeinvesting.com</a> or join us on Reddit <a target='_blank' href="https://www.reddit.com/r/DecodeInvesting/">/r/DecodeInvesting</a>.
          We would love to hear your feedback.
        </div>
      </p>
    </div>
  );
}

export default ContactUs;
